import { createAsyncThunk } from '@reduxjs/toolkit';
import trucksInfoRepository from 'modules/inbound/entriesST12/infractructure/repositories/trucksInfoRepository';

const getTrucksInPlantByWorkshopData = createAsyncThunk(
  'entriesST12TrucksInfo/getTrucksInPlantByWorkshopData',
  async (params: {
    queryParams: {
      workshop_id: string;
      min_dlz_hours: string | number;
    };
  }) => {
    const response = await trucksInfoRepository.getTrucksInPlantByWorkshopData(
      params
    );
    return response;
  }
);

const getTrucksInParkingData = createAsyncThunk(
  'entriesST12TrucksInfo/getTrucksInParkingData',
  async () => {
    const response = await trucksInfoRepository.getTrucksInParkingData();
    return response;
  }
);

const getUnloadingPointsAverageDlzData = createAsyncThunk(
  'entriesST12TrucksInfo/getUnloadingPointsAverageDlzData',
  async () => {
    const response =
      await trucksInfoRepository.getUnloadingPointsAverageDlzData();
    return response;
  }
);

const getTrucksInPlantByUnloadingBufferData = createAsyncThunk(
  'entriesST12TrucksInfo/getTrucksInPlantByUnloadingBufferData',
  async () => {
    const response =
      await trucksInfoRepository.getTrucksInPlantByUnloadingBufferData();
    return response;
  }
);

const getTrucksInPlantWaitingToArriveData = createAsyncThunk(
  'entriesST12TrucksInfo/getTrucksInPlantWaitingToArriveData',
  async () => {
    const response =
      await trucksInfoRepository.getTrucksInPlantWaitingToArriveData();
    return response;
  }
);

const getTrucksInPlantUrgentData = createAsyncThunk(
  'entriesST12TrucksInfo/getTrucksInPlantUrgentData',
  async (params: { queryParams: { workshop_id: string } }) => {
    const response = await trucksInfoRepository.getTrucksInPlantUrgentData(
      params
    );
    return response;
  }
);

export {
  getTrucksInPlantByWorkshopData,
  getTrucksInParkingData,
  getUnloadingPointsAverageDlzData,
  getTrucksInPlantByUnloadingBufferData,
  getTrucksInPlantWaitingToArriveData,
  getTrucksInPlantUrgentData
};
